export default {
  title: {
    nl: 'Enter your username'
  },

  description: {
    nl: 'In order to save your score and show it on leaderboard we need your username.'
  },

  placeholder: {
    nl: 'Your username'
  },

  error: {
    nl: 'Please enter a unique username.'
  },

  submit: {
    nl: 'Submit'
  }
};
